export default __webpack_public_path__ + "static/media/assignement.d0e09e08.jpeg";